import { DwellingType } from "@/types/form";

/** Every dwelling type the residence grid can show; each country picks a subset. */
export const GRID_DWELLING_TYPES = [
	DwellingType.OwnHouse,
	DwellingType.RentalApartment,
	DwellingType.LivingWithParents,
	DwellingType.OwnApartment,
	DwellingType.Other,
] as const;

export type GridDwellingType = (typeof GRID_DWELLING_TYPES)[number];

export const dwellingRequiresCost = (type?: DwellingType) => type !== undefined;
